/* DON'T EDIT THIS FILE: edit original and run build again */ import { AlycTenantHandler } from "../../../framework/tenant-handlers/alyc-tenant-handler.ts";
import { BaseLineOptions } from "../../../framework/tenant-handlers/base-line-options.ts";
import { cgbLineOptions } from "./cgb-line-options.ts";
import { cgbTenant } from "./code.ts";
import { cgbFullLabel } from "./full-label.ts";
import { cgbLabel } from "./label.ts";

class CapitalGainBursatilTenantHandler extends AlycTenantHandler {
  getCode(): string {
    return cgbTenant;
  }

  getPathLabel(): string | null {
    return "capital-gain-bursatil";
  }

  getLabel(): string {
    return cgbLabel;
  }

  getFullLabel(): string {
    return cgbFullLabel;
  }

  getLineOptions(): BaseLineOptions {
    return cgbLineOptions;
  }

  getNotificationsFrom(): string {
    return "no-responder@matchfin.ar";
  }

  getCuit(): string | null {
    return "30-71651436-2";
  }

  getCnvRegistryId(): string | null {
    return "1147"; // This is not a CNV registry id, as cgb it's not an ALYC ( it's an a AAGI (Agente Asesor Golbal de Inversiones))
  }

  publishesInMarketplace(): boolean {
    return true;
  }

  hasOpinionReportSection(): boolean {
    return false;
  }

  hasGrantedLineSection(): boolean {
    return true;
  }

  supportsRiskMatrix(): boolean {
    return false;
  }
}

const gcbTenantHandler = new CapitalGainBursatilTenantHandler();

export default gcbTenantHandler;
